const getLocalVehicles = electricVehicles => {
  return electricVehicles.filter(ev => {
    if(ev.locally_available && ev.msrp < 50000) {
      return true;
    } else {
      return false;
    }
  });
};

export default getLocalVehicles;
